export default __webpack_public_path__ + "static/media/location.bb87e124.png";